const settings = window.wc.wcSettings.getSetting( 'eghl_data', {} );
const label = window.wp.htmlEntities.decodeEntities( settings.title ) || window.wp.i18n.__( 'eGHL', 'eghl' );
const Content = () => {
    return window.wp.htmlEntities.decodeEntities( settings.description || window.wp.i18n.__( 'Pay with eGHL via Credit / Debit Card', 'eghl' ) );
};
const Block_Gateway = {
    name: 'eghl',
    label: label,
    content: Object( window.wp.element.createElement )( Content, null ),
    edit: Object( window.wp.element.createElement )( Content, null ),
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};
window.wc.wcBlocksRegistry.registerPaymentMethod( Block_Gateway );